import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import { Alert } from 'frontend-component-library';

class Form extends PureComponent {
  constructor(props) {
    super(props);

    let formData = {};
    React.Children.forEach(props.children, child => {
      if (!child.props.name) {
        throw new Error('Form inputs must have a name associated with them.');
      }

      formData[child.props.name] = child.props.defaultValue;
    });

    this.state = {
      formData,
      validationErrors: {},
    };
  }

  handleInputChange = (name, value) => {
    // Update formData
    const formData = {
      ...this.state.formData,
      [name]: value,
    };

    this.setState({
      formData,
      validationErrors: this.getValidationErrors(formData),
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    this.props.onSubmit(this.state.formData);
  };

  getValidationErrors = formData => {
    const { children } = this.props;

    let errors = {};
    React.Children.forEach(children, child => {
      const { validationCallback, name } = child.props;
      if (validationCallback) {
        let error = validationCallback(formData);
        if (error) {
          errors[name] ? errors[name].push(error) : (errors[name] = [error]);
        }
      }
    });
    return errors;
  };

  getNonFormErrors = () => {
    const { errors: allErrors } = this.props;
    const inputKeys = Object.keys(this.state.formData);
    const errors = Object.keys(allErrors).reduce((errors, errorKey) => {
      return !inputKeys.includes(errorKey)
        ? errors.concat(allErrors[errorKey])
        : errors;
    }, []);
    if (!errors.length) {
      return null;
    } else {
      return (
        <ul>
          {errors.map((error, i) => {
            return <li key={i}>{error}</li>;
          })}
        </ul>
      );
    }
  };

  renderChildren = () => {
    return React.Children.map(this.props.children, child => {
      const { name } = child.props;
      let errors = this.state.validationErrors[name] || this.props.errors[name];
      return React.cloneElement(child, {
        onChange: this.handleInputChange.bind(this, name),
        value: this.state.formData[name],
        disabled: this.props.disabled,
        errors: errors,
      });
    });
  };

  render() {
    const { disabled } = this.props;
    const hasValidationErrors = !isEmpty(this.state.validationErrors);
    return (
      <form
        onSubmit={this.handleSubmit}
        className={`Form ${this.props.className}`}
      >
        <Alert type="error">{this.getNonFormErrors()}</Alert>
        {this.renderChildren()}
        <button
          type="submit"
          className="Form-submit-btn btn btn-primary"
          disabled={disabled || hasValidationErrors}
        >
          {this.props.submitText}
        </button>
      </form>
    );
  }
}

Form.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  submitText: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
};

Form.defaultProps = {
  submitText: 'Submit',
  disabled: false,
  errors: {},
  className: '',
};

export default Form;



// WEBPACK FOOTER //
// ./src/Components/Form.js